// https://github.com/ThirdCornerLLC/tc-grid
import { tcGridDirective } from './tcGrid.directive';
import { tcColumnDirective } from './tcColumn.directive';

export const TcGridModule = angular
    .module('tc-grid', [])
    .directive('tcGrid', tcGridDirective)
    .directive('tcColumn', tcColumnDirective).name;


// WEBPACK FOOTER //
// ./src/app/components/tcGrid/tcGrid.module.js